// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root___1lH7","title":"Header_title__gAKxY","left":"Header_left__3CiND","clinicName":"Header_clinicName__33lnp"};